module.exports = __webpack_public_path__ + "static/media/mda.993d542e.svg";